import jsPDF from 'jspdf';
import 'jspdf-autotable';

// INSIRA AQUI A LOGO DA EMPRESA EM BASE64
const LOGO_BASE64 = 'COLOQUE_A_SUA_LOGO_BASE64_AQUI'; 

const PRIMARY_COLOR = [22, 163, 74]; // #16a34a (Verde)
const SECONDARY_COLOR = [241, 245, 249]; // #f1f5f9 (Fundo cinza claro)
const TEXT_COLOR = [15, 23, 42]; // #0f172a (Escuro)
const ACCENT_RED = [220, 38, 38]; // #dc2626
const ACCENT_BLUE = [59, 130, 246]; // #3b82f6

const GerarRelatorioPDF = (
    equipe, 
    totalDespesas, 
    totalReceitas, 
    lucroLiquido, 
    resumoProducao, 
    desempenhoOperador, 
    dataInicio, 
    dataFim, 
    veiculos,
    chartImages = {} // Objeto contendo { despesasImg, receitasImg, balancoImg }
) => {
    const doc = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
    });

    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const margin = 15;
    let yOffset = margin;

    // --- FUNÇÕES UTILITÁRIAS ---
    const formatCurrency = (val) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(parseFloat(val) || 0);
    
    // Função de data blindada contra erros
    const formatDate = (dateInput) => {
        if (!dateInput) return '-';

        if (dateInput instanceof Date || Object.prototype.toString.call(dateInput) === '[object Date]') {
            return isNaN(dateInput) ? 'Data Inválida' : dateInput.toLocaleDateString('pt-BR');
        }

        const str = String(dateInput);
        if (str.includes('-')) {
            const parts = str.split('-');
            if (parts.length >= 3 && parts[0].length === 4) {
                const [y, m, d] = parts;
                return `${d.substring(0, 2)}/${m}/${y}`;
            }
        }

        const d = new Date(dateInput);
        if (!isNaN(d.getTime())) {
            return d.toLocaleDateString('pt-BR');
        }
        return str;
    };

    // --- HELPER PARA ADICIONAR IMAGEM MANTENDO PROPORÇÃO ---
    const addImageProportional = (base64Img, x, y, targetWidth) => {
        try {
            const imgProps = doc.getImageProperties(base64Img);
            const targetHeight = (imgProps.height * targetWidth) / imgProps.width;
            doc.addImage(base64Img, 'PNG', x, y, targetWidth, targetHeight);
            return targetHeight; // Retorna a altura usada para ajustar o layout
        } catch (e) {
            console.error("Erro ao renderizar imagem proporcional", e);
            return 0;
        }
    };

    // --- COMPONENTES DO LAYOUT ---

    const addHeader = () => {
        doc.setFillColor(...SECONDARY_COLOR);
        doc.rect(0, 0, pageWidth, 35, 'F');

        if (LOGO_BASE64 && LOGO_BASE64.length > 100) {
            try {
                doc.addImage(LOGO_BASE64, 'PNG', margin, 5, 25, 25);
            } catch (e) {
                console.warn("Logo inválida.");
            }
        }

        doc.setTextColor(...PRIMARY_COLOR);
        doc.setFont('Helvetica', 'bold');
        doc.setFontSize(22);
        doc.text("RELATÓRIO DE GESTÃO", pageWidth - margin, 18, { align: 'right' });
        
        doc.setTextColor(...TEXT_COLOR);
        doc.setFontSize(10);
        doc.setFont('Helvetica', 'normal');
        
        const hoje = new Date().toLocaleDateString('pt-BR');
        const hora = new Date().toLocaleTimeString('pt-BR');
        const nomeEquipe = equipe.nome ? equipe.nome.toUpperCase() : 'N/A';
        
        doc.text(`Equipe: ${nomeEquipe}`, pageWidth - margin, 24, { align: 'right' });
        doc.text(`Gerado em: ${hoje} às ${hora}`, pageWidth - margin, 29, { align: 'right' });

        yOffset = 45;
    };

    const addFooter = (pageNumber) => {
        doc.setFontSize(8);
        doc.setTextColor(150, 150, 150);
        doc.text(`Página ${pageNumber}`, pageWidth / 2, pageHeight - 10, { align: 'center' });
        doc.text("Sistema de Gestão de Colheita - Confidencial", pageWidth - margin, pageHeight - 10, { align: 'right' });
    };

    const addSectionTitle = (title) => {
        doc.setFillColor(...PRIMARY_COLOR);
        doc.rect(margin, yOffset, 2, 7, 'F');
        doc.setFont('Helvetica', 'bold');
        doc.setFontSize(14);
        doc.setTextColor(...TEXT_COLOR);
        doc.text(title, margin + 4, yOffset + 5);
        yOffset += 12;
    };

    const checkPageBreak = (neededSpace) => {
        if (yOffset + neededSpace > pageHeight - 20) {
            doc.addPage();
            addHeader(); 
            return true;
        }
        return false;
    };

    // --- GERAÇÃO ---

    addHeader();

    // 1. PERÍODO
    doc.setFontSize(11);
    doc.setTextColor(50, 50, 50);
    doc.text(`Período de Análise: ${formatDate(dataInicio)} até ${formatDate(dataFim)}`, margin, yOffset);
    yOffset += 15;

    // 2. RESUMO FINANCEIRO
    addSectionTitle("Resumo Financeiro");
    
    const cardWidth = (pageWidth - (margin * 2) - 10) / 3;
    const cardHeight = 25;
    
    // Card Receita
    doc.setFillColor(240, 253, 244);
    doc.setDrawColor(...PRIMARY_COLOR);
    doc.roundedRect(margin, yOffset, cardWidth, cardHeight, 3, 3, 'FD');
    doc.setFontSize(9);
    doc.setTextColor(...PRIMARY_COLOR);
    doc.text("RECEITA TOTAL", margin + 5, yOffset + 8);
    doc.setFontSize(14);
    doc.setFont('Helvetica', 'bold');
    doc.text(formatCurrency(totalReceitas), margin + 5, yOffset + 18);

    // Card Despesa
    const xDespesa = margin + cardWidth + 5;
    doc.setFillColor(254, 242, 242);
    doc.setDrawColor(...ACCENT_RED);
    doc.roundedRect(xDespesa, yOffset, cardWidth, cardHeight, 3, 3, 'FD');
    doc.setFontSize(9);
    doc.setTextColor(...ACCENT_RED);
    doc.setFont('Helvetica', 'bold');
    doc.text("DESPESA TOTAL", xDespesa + 5, yOffset + 8);
    doc.setFontSize(14);
    doc.text(formatCurrency(totalDespesas), xDespesa + 5, yOffset + 18);

    // Card Lucro
    const xLucro = xDespesa + cardWidth + 5;
    const isPositive = lucroLiquido >= 0;
    const bgLucro = isPositive ? [239, 246, 255] : [254, 242, 242];
    const colorLucro = isPositive ? ACCENT_BLUE : ACCENT_RED;
    
    doc.setFillColor(...bgLucro);
    doc.setDrawColor(...colorLucro);
    doc.roundedRect(xLucro, yOffset, cardWidth, cardHeight, 3, 3, 'FD');
    doc.setFontSize(9);
    doc.setTextColor(...colorLucro);
    doc.setFont('Helvetica', 'bold');
    doc.text("LUCRO LÍQUIDO", xLucro + 5, yOffset + 8);
    doc.setFontSize(14);
    doc.text(formatCurrency(lucroLiquido), xLucro + 5, yOffset + 18);

    yOffset += cardHeight + 15;

    // 3. GRÁFICOS (CORRIGIDOS PARA MANTER PROPORÇÃO)
    
    // Balanço (Ocupa largura total)
    if (chartImages.balancoImg) {
        checkPageBreak(90);
        addSectionTitle("Balanço Financeiro");
        // Largura de 170mm (quase a pagina toda) e altura calculada
        const hUsed = addImageProportional(chartImages.balancoImg, margin, yOffset, 170);
        yOffset += hUsed + 10;
    }

    // Pizza (Despesas) e Barras (Receita) lado a lado
    if (chartImages.despesasImg || chartImages.receitasImg) {
        // Verifica se cabe na página, assumindo uma altura média de 90mm
        checkPageBreak(90);
        const startYCharts = yOffset;
        let maxH = 0;
        
        if (chartImages.despesasImg) {
            doc.setFontSize(10);
            doc.setTextColor(...TEXT_COLOR);
            doc.text("Distribuição de Despesas", margin, startYCharts);
            
            // Define largura fixa de 85mm (metade da área útil), altura auto
            const h = addImageProportional(chartImages.despesasImg, margin, startYCharts + 5, 85);
            maxH = Math.max(maxH, h);
        }

        if (chartImages.receitasImg) {
            doc.setFontSize(10);
            doc.setTextColor(...TEXT_COLOR);
            // Posiciona na metade da página
            const xPos = pageWidth / 2 + 5;
            doc.text("Evolução de Receita", xPos, startYCharts);
            
            const h = addImageProportional(chartImages.receitasImg, xPos, startYCharts + 5, 85);
            maxH = Math.max(maxH, h);
        }
        
        yOffset += maxH + 20; // Avança baseado no gráfico mais alto
    }

    // 4. TABELA
    checkPageBreak(40);
    addSectionTitle("Frota Vinculada");

    const tableHeaders = [["ID", "MODELO", "PLACA / CHASSI", "OPERADOR ATUAL"]];
    const tableData = veiculos.map(v => [
        v.id,
        v.modelo,
        v.placa_ou_chassi,
        v.operador
    ]);

    doc.autoTable({
        head: tableHeaders,
        body: tableData,
        startY: yOffset,
        theme: 'grid',
        headStyles: { fillColor: PRIMARY_COLOR, textColor: [255, 255, 255], fontStyle: 'bold' },
        styles: { fontSize: 9, cellPadding: 3 },
        columnStyles: { 0: { cellWidth: 15 }, 1: { cellWidth: 60 } },
        margin: { left: margin, right: margin }
    });
    
    yOffset = doc.lastAutoTable.finalY + 15;

    // 5. RODAPÉ
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        addFooter(i);
    }

    const nomeSeguro = equipe.nome ? equipe.nome.replace(/\s+/g, '_') : 'Equipe';
    const filename = `Relatorio_${nomeSeguro}_${new Date().getTime()}.pdf`;
    doc.save(filename);
};

export default GerarRelatorioPDF;